<div class="dialog__wrapper">
  <div class="dialog__header" mat-dialog-title>
    <h4 class="dialog__title">{{ addNewWordMode ? 'Add word' : 'Edit word' }}</h4>
    <button mat-dialog-close mat-icon-button>
      <mat-icon mat-button class="icon" fontIcon="close"></mat-icon>
    </button>
  </div>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="handleSubmit()">
      <mat-dialog-content class="dialog__content">
        <mat-form-field>
          <mat-label>Word</mat-label>
          <input matInput formControlName="word" />
          <mat-error>{{ errorMessage }}</mat-error>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button [disabled]="maskService.isVisible.value" mat-raised-button>Confirm</button>
        <button
          type="button"
          [disabled]="maskService.isVisible.value"
          mat-raised-button
          class="button--secondary button--pad-right"
          mat-dialog-close
        >
          Cancel
        </button>
      </mat-dialog-actions>
    </form>
  }
</div>
